import { LifebuoyIcon } from './LifebuoyIcon';

/**
 * author: Simran
 * id 7936EB1E-FCE1-4501-A339-C5EB7E4301E9
 * name lifebuoy
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lifebuoy.svg
 * tags
 * - Transportation + Water 
 */
export const OverboardIcon = LifebuoyIcon;
export default OverboardIcon